
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./App": () => {
return Promise.all([__webpack_require__.e("97"), __webpack_require__.e("92")]).then(() => (() => (__webpack_require__(935))));
},
"./Input": () => {
return __webpack_require__.e("275").then(() => (() => (__webpack_require__(990))));
},
"./VehicleInspection": () => {
return __webpack_require__.e("97").then(() => (() => (__webpack_require__(472))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };